const C = "HISTORY_PREVIEW_DECLARATION";

export default {
    CHANGE_INVOICE_DETAIL: `${C}_CHANGE_INVOICE_DETAIL`,
    RESET_DATA: `${C}_RESET_DATA`,
    ACTIVE_SCREEN_STATUS: `${C}_ACTIVE_SCREEN_STATUS`,
}